// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M8.293 17.293a1 1 0 0 0 1.414 1.414l-1.414-1.414zM15 12l.707.707a1 1 0 0 0 0-1.414L15 12zM9.707 5.293a1 1 0 1 0-1.414 1.414l1.414-1.414zm0 13.414l6-6-1.414-1.414-6 6 1.414 1.414zm6-7.414l-6-6-1.414 1.414 6 6 1.414-1.414z%27 fill=%27%236f767e%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AB1hLwr93Z3EtIpnnasc {
  display: table-row;
  transition: all 0.2s;
}
.dark-mode .AB1hLwr93Z3EtIpnnasc {
  border-color: #272B30;
}

@media only screen and (min-width: 1024px) {
  .AB1hLwr93Z3EtIpnnasc:hover {
    background: #F4F4F4;
  }
  .dark-mode .AB1hLwr93Z3EtIpnnasc:hover {
    background: #272B30;
  }
  .AB1hLwr93Z3EtIpnnasc:hover ._ZEHq3nuaylOV3SQTEcy {
    background: #FCFCFC;
  }
  .dark-mode .AB1hLwr93Z3EtIpnnasc:hover ._ZEHq3nuaylOV3SQTEcy {
    background: #111315;
  }
}
.AB1hLwr93Z3EtIpnnasc:last-child ._oc9S2OS2dukGdsiM9U9:after {
  display: none;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH:hover {
  background: none;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH ._oc9S2OS2dukGdsiM9U9:not(:first-child):not(:nth-child(2)) {
  display: none;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH ._oc9S2OS2dukGdsiM9U9:nth-child(2):after {
  right: 12px;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH.DFXZZbUSDXNj2_CfnyCN {
  background: #EFEFEF;
}
.dark-mode .AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH.DFXZZbUSDXNj2_CfnyCN {
  background: #272B30;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px rgba(255, 255, 255, 0.08);
}

.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH.DFXZZbUSDXNj2_CfnyCN ._oc9S2OS2dukGdsiM9U9:first-child {
  border-radius: 12px 0 0 12px;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH.DFXZZbUSDXNj2_CfnyCN ._oc9S2OS2dukGdsiM9U9:nth-child(2) {
  padding-right: 40px;
  border-radius: 0 12px 12px 0;
}
.AB1hLwr93Z3EtIpnnasc.HZTjq62BhpvW3xW263EH.DFXZZbUSDXNj2_CfnyCN ._oc9S2OS2dukGdsiM9U9:nth-child(2):before {
  content: "";
  position: absolute;
  top: 50%;
  right: 12px;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/100% auto;
}

._oc9S2OS2dukGdsiM9U9 {
  position: relative;
  display: table-cell;
  vertical-align: top;
  padding: 16px 12px;
  color: #1A1D1F;
}
.dark-mode ._oc9S2OS2dukGdsiM9U9 {
  color: #FCFCFC;
}

._oc9S2OS2dukGdsiM9U9:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  background: #EFEFEF;
}
.dark-mode ._oc9S2OS2dukGdsiM9U9:after {
  background: #272B30;
}

._oc9S2OS2dukGdsiM9U9:first-child {
  width: 0px;
  border-radius: 8px 0 0 8px;
  font-size: 0;
}
._oc9S2OS2dukGdsiM9U9:first-child:after {
  left: 12px;
}
._oc9S2OS2dukGdsiM9U9:last-child {
  border-radius: 0 8px 8px 0;
}
._oc9S2OS2dukGdsiM9U9:last-child:after {
  right: 12px;
}

.O0SCay5bfYMgiYTwr4gr {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.2s;
}
.O0SCay5bfYMgiYTwr4gr:hover {
  color: #2A85FF;
}
.O0SCay5bfYMgiYTwr4gr ._D7cRNtO2kuueuMxMJga {
  display: none;
}

.ro03FxDrocsm8fTD45Ja {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}
.dark-mode .ro03FxDrocsm8fTD45Ja {
  color: #9A9FA5;
}

.QZAp3qVxskH4lMLzyUIW {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  margin-right: 12px;
  border-radius: 50%;
  overflow: hidden;
}
.QZAp3qVxskH4lMLzyUIW img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.IO5NvKEtKnF7n6VuJTed {
  max-width: 160px;
  margin-bottom: 4px;
}

._D7cRNtO2kuueuMxMJga {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #6F767E;
}

.zxSHtwOVhVG_EvfJINg7 {
  display: inline-flex;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .zxSHtwOVhVG_EvfJINg7 {
    flex-direction: column;
    align-items: flex-end;
  }
}

._ZEHq3nuaylOV3SQTEcy {
  display: inline-block;
  padding: 0 8px;
  border-radius: 6px;
  background: #EFEFEF;
  transition: backround 0.2s;
}
.dark-mode ._ZEHq3nuaylOV3SQTEcy {
  background: #272B30;
}

.bJBPUn3BuygCeOcyjRLO {
  margin-left: 8px;
}
@media only screen and (max-width: 767px) {
  .bJBPUn3BuygCeOcyjRLO {
    margin: 4px 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ranking/Table/Row/Row.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,oBAAA;AADJ;ACyLa;EDtLL,qBCwCH;ADxCL;;ACiLI;EDhLA;IAEQ,mBCiCP;ED/BH;ECiLW;IDjLG,mBCmCX;EDhCH;EAFU;IACI,mBC4BX;EDxBH;EC2KW;ID7KO,mBCiCf;ED5BH;AACF;AAJQ;EACI,aAAA;AAMZ;AAJQ;EACI,gBAAA;AAMZ;AAJY;EACI,aAAA;AAMhB;AAJgB;EACI,WAAA;AAMpB;AALI;EACI,mBCcH;ADPL;ACwJa;ED7JD,mBCeP;EDdO,+FAAA;AAQZ;;AANY;EACI,4BAAA;AAShB;AARY;EACI,mBAAA;EACA,4BAAA;AAUhB;AATgB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,+EAAA;AAWpB;;AATA;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCPC;ADmBL;AC0Ha;EDpIL,cCfH;AD4BL;;AAZI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,mBCrBH;ADoCL;AC6Ga;EDzHD,mBCrBP;ADoCL;;AAdI;EACI,UAAA;EACA,0BAAA;EACA,YAAA;AAiBR;AAfQ;EACI,UAAA;AAiBZ;AAhBI;EACI,0BAAA;AAkBR;AAjBQ;EACI,WAAA;AAmBZ;;AAjBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAoBJ;AAnBI;EACI,cCxDH;AD6EL;AApBI;EACI,aAAA;AAsBR;;AApBA;ECoBI,eAAA;EACA,gBAAA;EACA,yBAAA;EDpBA,cChDC;ADyEL;ACuEa;ED9FL,cC5CE;ADsEV;;AAxBA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA2BJ;AA1BI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AA4BR;;AA1BA;EACI,gBAAA;EACA,kBAAA;AA6BJ;;AA1BA;ECzBI,eAAA;EACA,gBAAA;EACA,yBAAA;EDyBA,cCvEC;ADsGL;;AA5BA;EACI,oBAAA;EACA,mBAAA;AA+BJ;ACvII;EDsGJ;IAIQ,sBAAA;IACA,qBAAA;EAiCN;AACF;;AAhCA;EACI,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBCtFC;EDuFD,0BAAA;AAmCJ;ACuBa;EDxDL,mBCtFH;AD0HL;;AAlCA;EACI,gBAAA;AAqCJ;AC5JI;EDsHJ;IAGQ,eAAA;EAuCN;AACF","sourcesContent":["@import ../../../../styles/helpers\n\n.row\n    display: table-row\n    transition: all .2s\n    +dark\n        border-color: $n6\n    &:hover\n        +rmin(1024)\n            background: $n2\n            +dark\n                background: $n6\n            .price\n                background: $n1\n                +dark\n                    background: $n8\n    &:last-child\n        .col:after\n            display: none\n    &.active\n        &:hover\n            background: none\n        .col\n            &:not(:first-child):not(:nth-child(2))\n                display: none\n            &:nth-child(2)\n                &:after\n                    right: 12px\n    &.active.selected\n        background: $n3\n        +dark\n            background: $n6\n            box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px rgba(255, 255, 255, 0.08)\n        .col\n            &:first-child\n                border-radius: 12px 0 0 12px\n            &:nth-child(2)\n                padding-right: 40px\n                border-radius: 0 12px 12px 0\n                &:before\n                    content: \"\"\n                    position: absolute\n                    top: 50%\n                    right: 12px\n                    width: 24px\n                    height: 24px\n                    transform: translateY(-50%)\n                    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Cpath d='M8.293 17.293a1 1 0 0 0 1.414 1.414l-1.414-1.414zM15 12l.707.707a1 1 0 0 0 0-1.414L15 12zM9.707 5.293a1 1 0 1 0-1.414 1.414l1.414-1.414zm0 13.414l6-6-1.414-1.414-6 6 1.414 1.414zm6-7.414l-6-6-1.414 1.414 6 6 1.414-1.414z' fill='%236f767e'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto\n    \n.col\n    position: relative\n    display: table-cell\n    vertical-align: top\n    padding: 16px 12px\n    color: $n7\n    +dark\n        color: $n1\n    &:after\n        content: \"\"\n        position: absolute\n        left: 0\n        bottom: 0\n        right: 0\n        height: 1px\n        background: $n3\n      \n        +dark\n            background: $n6\n    &:first-child\n        width: 0px\n        border-radius: 8px 0 0 8px\n        font-size: 0\n       \n        &:after\n            left: 12px\n    &:last-child\n        border-radius: 0 8px 8px 0\n        &:after\n            right: 12px\n\n.item\n    display: flex\n    align-items: center\n    cursor: pointer\n    transition: color .2s\n    &:hover\n        color: $p1\n    .email\n        display: none\n\n.city\n    +caption1\n    color: $n4\n    +dark\n        color: $shades1\n\n.avatar\n    flex-shrink: 0\n    width: 48px\n    height: 48px\n    margin-right: 12px\n    border-radius: 50%\n    overflow: hidden\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n\n.user\n    max-width: 160px\n    margin-bottom: 4px\n\n\n.email\n    +base2\n    color: $n4\n\n\n.lifetime\n    display: inline-flex\n    align-items: center\n    +m\n        flex-direction: column\n        align-items: flex-end\n\n.price\n    display: inline-block\n    padding: 0 8px\n    border-radius: 6px\n    background: $n3\n    transition: backround .2s\n    +dark\n        background: $n6\n\n.balance\n    margin-left: 8px\n    +m\n        margin: 4px 0 0\n\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `AB1hLwr93Z3EtIpnnasc`,
	"price": `_ZEHq3nuaylOV3SQTEcy`,
	"col": `_oc9S2OS2dukGdsiM9U9`,
	"active": `HZTjq62BhpvW3xW263EH`,
	"selected": `DFXZZbUSDXNj2_CfnyCN`,
	"item": `O0SCay5bfYMgiYTwr4gr`,
	"email": `_D7cRNtO2kuueuMxMJga`,
	"city": `ro03FxDrocsm8fTD45Ja`,
	"avatar": `QZAp3qVxskH4lMLzyUIW`,
	"user": `IO5NvKEtKnF7n6VuJTed`,
	"lifetime": `zxSHtwOVhVG_EvfJINg7`,
	"balance": `bJBPUn3BuygCeOcyjRLO`
};
export default ___CSS_LOADER_EXPORT___;
